<template>
  <v-app id="inspire">
    <v-content class="register-frame">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 ml-5">
              <v-toolbar color="#9ccc3c" dark flat>
                <v-toolbar-title>Mascota</v-toolbar-title>
                <v-spacer />
                <v-toolbar-title>
                  <v-img
                    :src="require('../../assets/ObiPetsLogo.svg')"
                    class="my-3"
                    contain
                    height="50"
                  />
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form>
                  <form-wrapper :validator="$v.form">
                    <div style="margin-bottom: 20px">
                      <form-summary />
                    </div>

                    <form-group name="name">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          outlined
                          v-bind="attrs"
                          append-icon="mdi-paw"
                          v-model="form.name"
                          hint="2 caracteres requeridos"
                          label="Nombre"
                          @input="$v.form.name.$touch()"
                        />
                      </template>
                    </form-group>

                    <form-group name="gender">
                      <template slot-scope="{ attrs }">
                        <v-select
                          v-on:keyup="keymonitor('gender')"
                          id="gender"
                          outlined
                          append-icon="mdi-gender-male-female"
                          v-bind="attrs"
                          v-model="form.gender"
                          label="Sexo"
                          :items="genders"
                          @input="$v.form.gender.$touch()"
                        ></v-select>
                      </template>
                    </form-group>

                    <form-group name="dateBirth">
                      <v-menu
                        ref="fromDateMenu"
                        v-model="fromDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :success="form.dateBirth == '' ? false : true"
                            v-on:keyup="keymonitor('dateBirth')"
                            id="dateBirth"
                            label="Fecha de nacimiento"
                            outlined
                            :value="fromDateDisp"
                            append-icon="mdi-cake-variant"
                            v-on="on"
                            @input="$v.form.dateBirth.$touch()"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          ref="picker"
                          locale="es"
                          v-model="form.dateBirth"
                          no-title
                          @input="fromDateMenu = false"
                          :max="new Date().toISOString().substr(0, 10)"
                          min="1950-01-01"
                        ></v-date-picker>
                      </v-menu>
                    </form-group>
                    <form-group name="species">
                      <template slot-scope="{ attrs }">
                        <v-select
                          v-on:keyup="keymonitor('species')"
                          id="species"
                          @change="ShowChange"
                          outlined
                          append-icon="mdi-paw"
                          v-bind="attrs"
                          v-model="form.species"
                          label="Especie"
                          :items="species"
                          @input="$v.form.species.$touch()"
                        />
                      </template>
                    </form-group>
                    <form-group v-if="form.species === 'Perro'" name="race">
                      <template slot-scope="{ attrs }">
                        <v-autocomplete
                          @change="ShowChange"
                          outlined
                          label="Raza"
                          v-bind="attrs"
                          v-model="form.race"
                          :loading="loading"
                          :items="items"
                          :search-input.sync="search"
                          flat
                          hide-no-data
                          hide-details
                          @input="$v.form.race.$touch()"
                          append-icon="mdi-paw"
                          class="mb-6"
                        ></v-autocomplete>
                      </template>
                    </form-group>
                    <form-group v-if="form.species === 'Gato'" name="race">
                      <template slot-scope="{ attrs }">
                        <v-autocomplete
                          outlined
                          label="Raza"
                          v-bind="attrs"
                          v-model="form.race"
                          :loading="loading"
                          :items="items"
                          :search-input.sync="search"
                          cache-items
                          flat
                          hide-no-data
                          hide-details
                          @input="$v.form.race.$touch()"
                          append-icon="mdi-paw"
                          class="mb-6"
                        ></v-autocomplete>
                      </template>
                    </form-group>
                    <form-group v-if="form.species === 'Otro'" name="race">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          outlined
                          v-bind="attrs"
                          v-model="form.race"
                          append-icon="mdi-paw"
                          label="Raza"
                          placeholder="Escribe la raza..."
                          @input="$v.form.race.$touch()"
                        />
                      </template>
                    </form-group>
                    <form-group name="Image">
                      <v-btn
                        @click="pickFile"
                        color="primary"
                        rounded
                        depressed
                        style="text-transform:none;"
                        class="mb-5"
                      >
                        Añadir retrato
                        <v-icon>mdi-camera</v-icon>
                      </v-btn>
                      <!-- <v-file-input
                        class="d-none"  
                        :success="form.image == null ? false : true"
                        v-on:keyup="keymonitor('photo')"
                        id="photo"
                        ref="photo"
                        outlined
                        v-model="form.image"
                        accept="image/*"
                        append-icon="mdi-camera"
                        prepend-icon
                        label="Retrato"
                      />-->
                      <input
                        ref="photo"
                        class="d-none"
                        type="file"
                        accept="image/*"
                        @change="onFileChanged"
                      />
                      <!-- Codigo actualizacion de info -->
                      <div class="pictute-actual-container mt-5">
                        <v-img
                          class="img-actual"
                          :src="actualPicture"
                          contain
                        />
                      </div>
                      <!-- End Codigo actualizacion de info -->
                    </form-group>
                    <v-divider></v-divider>
                    <form-group name="vaccinated">
                      <template slot-scope="{ attrs }">
                        <v-container fluid>
                          <h4></h4>
                          <v-radio-group row :mandatory="false" v-bind="attrs">
                            <!--  <v-radio label="Si" value="si"></v-radio>
                            <v-radio label="No" value="no"></v-radio> -->
                          </v-radio-group>
                        </v-container>
                      </template>
                    </form-group>

                    <form-group name="vaccinated">
                      <template slot-scope="{ attrs }">
                        <v-container fluid>
                          <h4>¿Está Vacunado?</h4>
                          <v-radio-group
                            row
                            v-model="form.vaccinated"
                            :mandatory="false"
                            v-bind="attrs"
                            @input="$v.form.vaccinated.$touch()"
                          >
                            <v-radio label="Si" value="si"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                          </v-radio-group>
                        </v-container>
                      </template>
                    </form-group>
                    <form-group name="sterilized">
                      <template slot-scope="{ attrs }">
                        <v-container fluid>
                          <h4>¿Está esterilizado?</h4>
                          <v-radio-group
                            row
                            v-model="form.sterilized"
                            :mandatory="false"
                            v-bind="attrs"
                            @input="$v.form.sterilized.$touch()"
                          >
                            <v-radio label="Si" value="si"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                          </v-radio-group>
                        </v-container>
                      </template>
                    </form-group>
                    <form-group name="coexistAnimals">
                      <template slot-scope="{ attrs }">
                        <v-container fluid>
                          <h4>¿Convive con otros animales?</h4>
                          <v-radio-group
                            row
                            v-model="form.coexistAnimals"
                            :mandatory="false"
                            v-bind="attrs"
                            @input="$v.form.coexistAnimals.$touch()"
                          >
                            <v-radio label="Si" value="si"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                          </v-radio-group>
                        </v-container>
                      </template>
                    </form-group>
                    <form-group
                      v-if="form.coexistAnimals === 'si'"
                      name="coexistAnimalsDescription"
                    >
                      <template slot-scope="{ attrs }">
                        <v-textarea
                          label="¿Cuáles?"
                          auto-grow
                          outlined
                          rows="3"
                          row-height="25"
                          shaped
                          v-bind="attrs"
                          @input="$v.form.coexistAnimalsDescription.$touch()"
                          v-model="form.coexistAnimalsDescription"
                          append-icon="mdi-chart-bubble"
                        ></v-textarea>
                      </template>
                    </form-group>
                    <form-group name="coexistLittleChill">
                      <template slot-scope="{ attrs }">
                        <v-container fluid>
                          <h4>¿Convive con niños pequeños?</h4>
                          <v-radio-group
                            row
                            v-model="form.coexistLittleChill"
                            :mandatory="false"
                            v-bind="attrs"
                            @input="$v.form.coexistLittleChill.$touch()"
                          >
                            <v-radio label="Si" value="si"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                          </v-radio-group>
                        </v-container>
                      </template>
                    </form-group>
                    <form-group name="coexistAncient">
                      <template slot-scope="{ attrs }">
                        <v-container fluid>
                          <h4>¿Convive con adultos mayores?</h4>
                          <v-radio-group
                            row
                            v-model="form.coexistAncient"
                            :mandatory="false"
                            v-bind="attrs"
                            @input="$v.form.coexistAncient.$touch()"
                          >
                            <v-radio label="Si" value="si"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                          </v-radio-group>
                        </v-container>
                      </template>
                    </form-group>
                    <form-group name="sickness">
                      <template slot-scope="{ attrs }">
                        <v-container fluid>
                          <h4>¿Padece alguna enfermedad?</h4>
                          <v-radio-group
                            row
                            v-model="form.sickness"
                            :mandatory="false"
                            v-bind="attrs"
                            @input="$v.form.sickness.$touch()"
                          >
                            <v-radio label="Si" value="si"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                          </v-radio-group>
                        </v-container>
                      </template>
                    </form-group>
                    <form-group
                      v-if="form.sickness === 'si'"
                      name="sicknessDescription"
                    >
                      <template slot-scope="{ attrs }">
                        <v-textarea
                          label=" ¿Cuál?"
                          auto-grow
                          outlined
                          rows="3"
                          row-height="25"
                          shaped
                          v-bind="attrs"
                          @input="$v.form.sicknessDescription.$touch()"
                          v-model="form.sicknessDescription"
                          append-icon="mdi-chart-bubble"
                        ></v-textarea>
                      </template>
                    </form-group>
                    <form-group name="allergies">
                      <template slot-scope="{ attrs }">
                        <v-container fluid>
                          <h4>¿Tiene alguna alergia?</h4>
                          <v-radio-group
                            row
                            v-model="form.allergies"
                            :mandatory="false"
                            v-bind="attrs"
                            @input="$v.form.allergies.$touch()"
                          >
                            <v-radio label="Si" value="si"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                          </v-radio-group>
                        </v-container>
                      </template>
                    </form-group>
                    <form-group
                      v-if="form.allergies === 'si'"
                      name="allergiesDescription"
                    >
                      <template slot-scope="{ attrs }">
                        <v-textarea
                          label="¿A que?"
                          auto-grow
                          outlined
                          rows="3"
                          row-height="25"
                          shaped
                          v-bind="attrs"
                          @input="$v.form.allergiesDescription.$touch()"
                          v-model="form.allergiesDescription"
                          append-icon="mdi-chart-bubble"
                        ></v-textarea>
                      </template>
                    </form-group>
                    <form-group name="notes">
                      <template slot-scope="{ attrs }">
                        <v-textarea
                          label="Informacón adicional:"
                          auto-grow
                          outlined
                          rows="3"
                          row-height="25"
                          shaped
                          placeholder="Es un poco timido..."
                          v-bind="attrs"
                          @input="$v.form.notes.$touch()"
                          v-model="form.notes"
                          append-icon="mdi-note-text"
                        ></v-textarea>
                      </template>
                    </form-group>
                  </form-wrapper>

                  <p class="typo__p" v-if="submitStatus === 'OK'">
                    ¡Gracias por agregar su mascota!
                  </p>
                  <p class="typo__p" v-if="submitStatus === 'ERROR'">
                    Por favor, llene los campos correctamente..
                  </p>
                  <p class="typo__p" v-if="submitStatus === 'PENDING'">
                    Enviando...
                  </p>
                </form>
              </v-card-text>

              <v-card-actions>
                <!--    v-if="this.$route.params.id" -->
                <v-btn
                  color="red darken-1"
                  to="/dashboard/usuario"
                  style="color:#fff; text-transform:none;"
                  >Cancelar</v-btn
                >
                <v-spacer />
                <v-btn
                  v-if="this.$route.params.id"
                  color="#9ccc3c"
                  @click.prevent="submitModifyData"
                  style="text-transform:none; color:#fff;"
                  :disabled="$v.$invalid"
                  >Modificar datos</v-btn
                >
                <v-btn
                  v-else
                  color="#9ccc3c"
                  @click.prevent="submit"
                  style="text-transform:none"
                  :disabled="$v.$invalid"
                  >Agregar a "{{ form.name }}"</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
          <v-dialog v-model="dialog" :persistent="true" width="500">
            <v-card>
              <v-card-title class="headline"
                >¿Quieres agregar a otra mascota?</v-card-title
              >

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="red darken-1" text @click="finish"
                  >No, llévame al inicio.</v-btn
                >

                <v-btn color="green darken-1" text @click="addOtherPet"
                  >Aceptar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  mounted() {
    if (this.$route.params.id) {
      this.getMyPets().then((res) => {
        this.pets = res.results.map((item) => {
          item["showInfo"] = false;
          item["showLocation"] = false;
          this.user_profile = item["owner"].userprofile;
          return item;
        });
        this.setData(this.pets);
      });
    }
  },
  data() {
    return {
      imageData: null,
      selectedFile: null,
      actualSpecies: "",
      items: [],
      search: null,
      loading: false,
      user_profile: [],
      pets: [],
      date: null,
      dialog: false,
      genders: ["Hembra", "Macho"],
      species: ["Perro", "Gato", "Otro"],
      racedog: [
        "Mestizo",
        "Otro",
        "Affenpinscher",
        "Airedale terrier",
        "Aïdi",
        "Akita Americano",
        "Akita Inu",
        "Alano español",
        "Alaskan malamute",
        "American Hairless terrier",
        "American Staffordshire Terrier",
        "Antiguo Perro Pastor Inglés",
        "Australian Cobberdog",
        "Aussiedoodle",
        "Axzawakh",
        "Ballhuahua",
        "Berger de Picardie",
        "Bóxer",
        "Bardino (Perro majorero)",
        "Basenji",
        "Basset hound",
        "Beagle",
        "Beauceron",
        "Bichón maltés",
        "Bichon frisé",
        "Bloodhound",
        "Border collie",
        "Borzoi",
        "Boston terrier",
        "Braco alemán de pelo corto",
        "Braco alemán de pelo duro",
        "Braco de Auvernia",
        "Braco de Saint Germain",
        "Braco de Weimar",
        "Braco francés tipo Pirineos y Gascuña",
        "Braco húngaro",
        "Braco italiano",
        "Braco tirolés",
        "Bull Terrier",
        "Bulldog americano",
        "Bulldog francés",
        "Bulldog inglés",
        "Bullmastiff",
        "Cão da Serra da Estrela",
        "Cão da Serra de Aires",
        "Cão de Agua Português",
        "Cão de Castro Laboreiro",
        "Cão de Fila de São Miguel",
        "Can de palleiro",
        "Cackapoo",
        "Caniche",
        "Cavachón",
        "Cavopoo",
        "Cazador de alces noruego",
        "Chorkie",
        "Chihuahueño",
        "Chow chow",
        "Clumber spaniel",
        "Cocker spaniel americano",
        "Cocker spaniel inglés",
        "Collie",
        "Collie barbudo",
        "Crestado Chino",
        "Dálmata",
        "Dachshund",
        "Dobermann",
        "Dogo argentino",
        "Dogo de burdeos",
        "Dogo guatemalteco",
        "Eurasier",
        "Epagneul papillón",
        "Flat-Coated Retriever",
        "Frenchton",
        "Fox Terrier",
        "Foxhound americano",
        "Foxhound inglés",
        "Galgo español",
        "Galgo húngaro",
        "Galgo inglés",
        "Galgo italiano",
        "Gegar colombiano",
        "Goldendoodle",
        "Golden retriever",
        "Goldador",
        "Gran danés",
        "Greyhound",
        "Grifón belga",
        "Husky inu",
        "Husky siberiano",
        "Jack Russell Terrier",
        "Keeshond",
        "Kelpie Australiano",
        "Kerry blue terrier",
        "Komondor",
        "Kuvasz",
        "Labradooldle",
        "Labrador",
        "Lebrel afgano",
        "Lhasa apso",
        "Lobo de saarloos",
        "Mal-shi",
        "Maltés",
        "Maltiopoo",
        "Manchester terrier",
        "Mastín afgano",
        "Mastín del Pirineo",
        "Mastín español",
        "Mastín inglés",
        "Mastín napolitano",
        "Mastín tibetano",
        "Mucuchies",
        "Morkie",
        "Ovejero magallánico",
        "Pastor del Cáucaso",
        "Pastor alemán",
        "Pastor belga",
        "Pastor blanco suizo",
        "Pastor catalán",
        "Pastor croata",
        "Pastor de los Pirineos",
        "Pastor garafiano",
        "Pastor holandés",
        "Pastor leonés",
        "Pastor mallorquín",
        "Pastor peruano Chiribaya",
        "Pastor vasco",
        "Pekinés",
        "Pembroke Welsh Corgi",
        "Pequeño Lebrel Italiano",
        "Perdiguero francés",
        "Perdiguero portugués",
        "Perro cimarrón uruguayo",
        "Perro de agua americano",
        "Perro de agua español",
        "Perro de agua irlandés",
        "Perro de agua portugués",
        "Perro de Montaña de los Pirineos",
        "Perro dogo mallorquín",
        "Perro esquimal canadiense",
        "Perro pastor de las islas Shetland",
        "Perro peruano sin pelo",
        "Phalène",
        "Pinscher alemán",
        "Pinscher miniatura",
        "Pitbull",
        "Podenco andaluz",
        "Podenco canario",
        "Podenco ibicenco",
        "Podenco portugués",
        "Pointer",
        "Pomerania",
        "Presa canario",
        "Pug",
        "Puggle",
        "Puli",
        "Rafeiro do Alentejo",
        "Ratonero bodeguero andaluz",
        "Ratonero mallorquín",
        "Ratonero valenciano",
        "Rhodesian Ridgeback",
        "Rottweiler",
        "Saluki",
        "Samoyedo",
        "San Bernardo",
        "Sato",
        "Schnoodle",
        "Schnocker",
        "Schnauzer estándar",
        "Schnauzer gigante",
        "Schnauzer miniatura",
        "Setter inglés",
        "Setter irlandés",
        "Shar Pei",
        "Shiba Inu",
        "Shih Tzu",
        "Shih-poo",
        "Spitz finlandés",
        "Siberian husky",
        "Skye terrier",
        "Sussex spaniel",
        "Teddy roosevelt terrier",
        "Terranova",
        "Terrier alemán",
        "Terrier australiano",
        "Terrier brasileño",
        "Terrier chileno",
        "Terrier escocés",
        "Terrier galés",
        "Terrier irlandés",
        "Thai ridgeback",
        "Weimaraner",
        "West Highland White Terrier",
        "Whippet",
        "Xoloitzcuintle",
        "Yorkie poo",
        "Yorkshire terrier",
      ],
      racecat: [
        "Mestizo",
        "Otro",
        "Abisinio",
        "Africano doméstico",
        "American Curl",
        "American shorthair",
        "American wirehair",
        "Angora turco",
        "Aphrodite-s Giants",
        "Australian Mist",
        "Azul ruso",
        "Bengala",
        "Bobtail japonés",
        "Bombay",
        "Bosque de Noruega",
        "Brazilian Shorthair",
        "British Shorthair",
        "Burmés",
        "Burmilla",
        "California Spangled",
        "Ceylon",
        "Chartreux",
        "Cornish rex",
        "Cymric",
        "Deutsch Langhaar",
        "Devon rex",
        "Don Sphynx",
        "Dorado africano",
        "Europeo común",
        "Gato exótico",
        "German Rex",
        "Habana brown",
        "Himalayo",
        "Khao Manee",
        "Korat",
        "Maine Coon",
        "Manx",
        "Mau egipcio",
        "Munchkin",
        "Ocicat",
        "Ojos azules",
        "Oriental",
        "Oriental de pelo largo",
        "Persa",
        "Peterbald",
        "Pixi Bob",
        "Ragdoll",
        "Sagrado de Birmania",
        "Scottish Fold",
        "Selkirk rex",
        "Serengeti",
        "Seychellois",
        "Siamés",
        "Siamés Moderno",
        "Siamés Tradicional",
        "Siberiano",
        "Snowshoe",
        "Sphynx",
        "Tonkinés",
        "Van Turco",
      ],
      form: {
        name: "",
        species: "",
        gender: "",
        race: "",
        dateBirth: "",
        peteage: "",
        sterilized: "",
        vaccinated: "",
        coexistAnimals: "",
        coexistAnimalsDescription: "",
        coexistLittleChill: "",
        coexistAncient: "",
        sickness: "",
        sicknessDescription: "",
        allergies: "",
        allergiesDescription: "",
        notes: "",
        image: null,
      },
      actualPicture: "",
      submitStatus: null,
      minDate: "1925-01-05",
      maxDate: "2000-01-05",
      show1: false,
      fromDateMenu: false,
      disabled: true,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(48),
      },
      species: { required },
      gender: { required },
      race: { required },
      dateBirth: { required },
      sterilized: { required },
      vaccinated: { required },
      coexistAnimals: { required },
      coexistAnimalsDescription: { maxLength: maxLength(50) },
      coexistLittleChill: { required },
      coexistAncient: { required },
      sickness: { required },
      sicknessDescription: { maxLength: maxLength(50) },
      allergies: { required },
      allergiesDescription: { maxLength: maxLength(50) },
      notes: { maxLength: maxLength(250) },
    },
  },
  methods: {
    ...mapActions("pets", {
      newPet: "newPet",
      getMyPets: "getMyPets",
      modifyPetData: "modifyPetData",
    }),
    onFileChanged(e) {
      this.form.image = e.target.files[0];
      const input = this.$refs.photo;
      const files = input.files;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.actualPicture = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
      // do something
    },
    pickFile() {
      this.$refs.photo.click();
    },
    keymonitor(option) {
      var id = option;
      document.getElementById(id).click();
    },
    setData(pets) {
      for (let key in pets) {
        if (this.$route.params.id == pets[key].id) {
          console.log(pets[key].image);
          this.actualPicture = pets[key].image;
          delete pets[key].image;
          this.form = pets[key];
          this.items.push(this.form.race);
          this.select = this.form.race;
        }
      }
    },
    submitModifyData() {
      if (this.form.image == null) {
        this.$delete(this.form, "image");
        this.modifyPetDataPatch();
      } else {
        this.modifyPetDataPatch();
      }
    },
    modifyPetDataPatch() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        let formData = this.getformData();
        let id = this.$route.params.id;
        this.modifyPetData({ formData, id })
          .then(() => {
            this.submitStatus = "OK";
            this.$router.push({
              name: "userDash",
            });
          })
          .catch((err) => {
            alert({ err });
          });
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        this.newPet(this.getformData())
          .then(() => {
            this.submitStatus = "OK";
            this.dialog = true;
          })
          .catch((err) => {
            alert({ err });
          });
      }
    },
    setEage(eage) {
      this.form.peteage = eage;
    },
    getformData() {
      let formData = new FormData();
      for (let key in this.form) {
        // noinspection JSUnfilteredForInLoop
        formData.append(key, this.form[key]);
      }
      return formData;
    },
    addOtherPet() {
      this.$router.go();
    },
    finish() {
      this.dialog = false;
      this.$router.push({ name: "login" });
    },
    ShowChange() {
      this.actualSpecies = this.form.species;
      if (this.$route.params.id) {
        this.querySelections();
      }
    },
    querySelections(v) {
      this.loading = true;
      // Simulated ajax query
      if (this.actualSpecies == "Perro") {
        setTimeout(() => {
          this.items = this.racedog.filter((e) => {
            return (
              (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
            );
          });
          this.loading = false;
        }, 500);
      } else if (this.actualSpecies == "Gato") {
        setTimeout(() => {
          this.items = this.racecat.filter((e) => {
            return (
              (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
            );
          });
          this.loading = false;
        }, 500);
      }
    },
  },
  computed: {
    fromDateDisp() {
      let year = new Date().getFullYear();
      let birth = this.form.dateBirth;
      let birtyear = birth.substring(0, 4);
      let eage = year - birtyear;
      if (year === eage) {
        eage = 0;
      } else if (year !== eage) {
        this.setEage(eage);
      }

      return this.form.dateBirth;
      // format/do something with date
    },
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
    fromDateMenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
};
</script>
<style lang="scss" scoped>
.register-frame {
  background-image: url("../../assets/img/backgrounds/fondoazul.png");
  background-position: center center;
  background-size: cover;
}
</style>
